// Model.js
// -----------------------
// @module Case
define("Ames.CustomMerchantZone.CustomMerchantZone.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/CustomMerchantZone/SuiteScript2/CustomMerchantZone.Service.ss"
            ),
            true
        )
});
});
